import { render, staticRenderFns } from "./createdWhiteboard.vue?vue&type=template&id=b08d540c&scoped=true"
import script from "./createdWhiteboard.vue?vue&type=script&lang=js"
export * from "./createdWhiteboard.vue?vue&type=script&lang=js"
import style0 from "./createdWhiteboard.vue?vue&type=style&index=0&id=b08d540c&prod&scoped=true&lang=css"
import style1 from "./createdWhiteboard.vue?vue&type=style&index=1&id=b08d540c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08d540c",
  null
  
)

export default component.exports